import React, { useState } from "react";
import styled, { css } from "styled-components";

const Wrapper = styled.div`
	display: inline-block;
	position: relative;
`;

const Content = styled.div`
	width: 230px;
	position: absolute;
	border-radius: 5px;
	left: calc(100% - 5px);
	top: 50%;
	transform: translateX(0) translateY(-50%);
	padding: 7px;
	background: #f9f8f8;
	color: #1c3a58;
	font-size: 14px;
	z-index: 100;

	@media screen and (max-width: 500px) {
		width: 200px;
		font-size: 13px;

		${({ bottom }) =>
			bottom &&
			css`
				top: calc(100% + 5px);
				left: 50%;
				transform: translateX(-70%) translateY(0);
				width: 200px;
			`};

		${({ bottom }) =>
			bottom &&
			css`
				transform: translateX(-55%) translateY(0);
			`};
	}

	&::before {
		content: " ";
		border: solid transparent;
		height: 0;
		width: 0;
		position: absolute;
		pointer-events: none;
		border-width: 6px;
		margin-left: -5px;
		left: -6px;
		top: 50%;
		transform: translateX(0) translateY(-50%);
		border-right-color: #f9f8f8;

		@media screen and (max-width: 500px) {
			${({ bottom }) =>
				bottom &&
				css`
					top: 0;
					left: 50%;
					margin-top: -6px;
					border-top-color: #f9f8f8;
					transform: translateX(-50%) translateY(0);
					transform: rotate(-45deg);
				`};
		}
	}
`;

function LogoTooltip({ children, content, bottom, center }) {
	const [active, setActive] = useState(false);

	const showTip = () => {
		setActive(true);
	};

	const hideTip = () => {
		setActive(false);
	};

	return (
		<Wrapper onMouseEnter={showTip} onMouseLeave={hideTip}>
			{children}
			{active && (
				<Content bottom={bottom} center={center}>
					{content}
				</Content>
			)}
		</Wrapper>
	);
}

export default LogoTooltip;
